import {useQuery} from "@tanstack/react-query";
import {readOrderPta} from "../../../../../api/order/OrdersApi";
import {ordersDetailPtaInit} from "../state";

type Props = {
    param: string;
};

export const useReadOrderPta = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readOrderPta", param],
        queryFn: async () => await readOrderPta(param),
        select: (res) => res?.data.result ?? ordersDetailPtaInit,
        enabled: param !== ""
    });

    return {data};
};
